"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const icons_1 = require("@material-ui/icons");
const entity_ui_1 = require("@sierralabs/entity-ui");
const SelectQueryBuilder_1 = require("../query-builder/SelectQueryBuilder");
const QueryBuilderContext_1 = require("../QueryBuilderContext");
const AliasSelector_1 = __importDefault(require("./AliasSelector"));
const JoinCondition_1 = __importDefault(require("./JoinCondition"));
const QueryFieldSelector_1 = __importDefault(require("./QueryFieldSelector"));
const StyledDiv = styled_components_1.default.div `
  display: flex;
  align-items: flex-start;
  .on-label {
    margin-left: 6px;
    margin-right: 6px;
  }
  .separator {
    display: inline-block;
    padding: 4px 6px;
  }
  .input-field {
    margin-left: 6px;
    .MuiOutlinedInput-adornedEnd {
      padding-right: 8px;
    }
    .MuiInputBase-input {
      width: 96px;
      padding-left: 9px;
      padding-top: 9px;
      padding-bottom: 9px;
    }
  }
`;
const joinOptions = [
    {
        value: 'LEFT',
        label: 'Left Join'
    },
    {
        value: 'INNER',
        label: 'Inner Join'
    }
];
const JoinSelector = ({ index, vertical, joinAttribute, configPath = 'config' }) => {
    var _a, _b, _c, _d;
    const { entities } = (0, entity_ui_1.useEntityContext)();
    const [direction, setDirection] = (0, react_1.useState)(joinOptions.find(o => o.value === joinAttribute.direction) || joinOptions[0]);
    const { queryManager } = (0, QueryBuilderContext_1.useQueryBuilderContext)();
    // use subquery config or main config
    const config = configPath
        ? queryManager.get(configPath)
        : queryManager.query.config;
    const [joinRelations, setJoinRelations] = (0, react_1.useState)([]);
    const hasSubQuery = !!((_a = joinAttribute.alias) === null || _a === void 0 ? void 0 : _a.subQuery);
    // custom alias for subQueries
    const getNextAlias = () => {
        const names = ((config === null || config === void 0 ? void 0 : config.joinAttributes) || []).map(attribute => { var _a; return ((_a = attribute.alias) === null || _a === void 0 ? void 0 : _a.name) || ''; });
        // avoid duplicates if they exist
        let i = 0;
        let name = `join${i}`;
        while (names.includes(name)) {
            name = `join${++i}`;
        }
        return name;
    };
    const updateAlias = (value) => {
        setAlias(value);
        queryManager.updateJoinAliasName(index, value, `${configPath}.joinAttributes`);
    };
    (0, react_1.useEffect)(() => {
        const handleChange = () => {
            var _a, _b;
            const joinRelations = [];
            if (!entities || !config)
                return;
            for (const entity of entities) {
                if (!entity.relations)
                    continue;
                // get alias of target relationship
                let alias = undefined;
                if (entity.tableName === ((_a = config.mainAlias) === null || _a === void 0 ? void 0 : _a.tablePath)) {
                    alias = config.mainAlias;
                }
                else {
                    const joinAttribute = (_b = config.joinAttributes) === null || _b === void 0 ? void 0 : _b.find(attribute => {
                        var _a;
                        if (!((_a = attribute.alias) === null || _a === void 0 ? void 0 : _a.tablePath))
                            return false;
                        return attribute.alias.tablePath === entity.tableName;
                    });
                    alias = joinAttribute === null || joinAttribute === void 0 ? void 0 : joinAttribute.alias;
                }
                if (alias) {
                    for (const relation of entity.relations) {
                        const targetEntity = entities.find(e => e.name === relation.target);
                        joinRelations.push({
                            alias: alias.name,
                            entity,
                            relation,
                            targetEntity
                        });
                    }
                }
            }
            setJoinRelations(joinRelations);
        };
        handleChange();
        queryManager.subscribe('change', handleChange);
        return () => {
            queryManager.unsubscribe('change', handleChange);
        };
    }, [config, entities, queryManager]);
    // const [join, setJoin] = useState<JoinRelation | undefined>(
    //   joinRelations.find(
    //     joinRelation =>
    //       joinAttribute.entityOrProperty === getEntityPropertyString(joinRelation)
    //   )
    // );
    const join = (0, react_1.useMemo)(() => joinRelations.find(joinRelation => joinAttribute.entityOrProperty ===
        getEntityPropertyString(joinRelation)), [joinRelations, joinAttribute]);
    const [alias, setAlias] = (0, react_1.useState)((_b = joinAttribute.alias) === null || _b === void 0 ? void 0 : _b.name);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(StyledDiv, { className: 'join-selector-container' },
            react_1.default.createElement(QueryFieldSelector_1.default, { className: 'join-type-selector', placeholder: 'Join', value: direction, options: joinOptions, getOptionLabel: option => (option === null || option === void 0 ? void 0 : option.label) || '', onChange: option => {
                    setDirection(option);
                    queryManager.updateJoinDirection(index, option.value, `${configPath}.joinAttributes`);
                } }),
            react_1.default.createElement("span", { className: 'separator' }, ":"),
            react_1.default.createElement(QueryFieldSelector_1.default, { className: 'join-relation-selector', placeholder: 'Relation', value: ((_d = (_c = config === null || config === void 0 ? void 0 : config.joinAttributes) === null || _c === void 0 ? void 0 : _c[index].alias) === null || _d === void 0 ? void 0 : _d.subQuery) ? 'subQuery' : join, options: ['subQuery', ...joinRelations], getOptionLabel: option => {
                    return option === 'subQuery'
                        ? 'Sub Query'
                        : option
                            ? getEntityPropertyString(option)
                            : '';
                }, onChange: option => {
                    const isSubQuery = option === 'subQuery';
                    const joinRelation = typeof option === 'object' ? option : undefined;
                    const alias = joinRelation
                        ? (0, lodash_1.camelCase)(joinRelation.relation.propertyName)
                        : getNextAlias();
                    queryManager.updateJoinEntityProperty(index, joinRelation ? getEntityPropertyString(joinRelation) : '', `${configPath}.joinAttributes`);
                    // remove condition when changing from subQuery
                    if (!isSubQuery) {
                        queryManager.updateJoinCondition(index, undefined, `${configPath}.joinAttributes`);
                    }
                    const joinAlias = {
                        type: 'join',
                        name: alias,
                        tablePath: joinRelation === null || joinRelation === void 0 ? void 0 : joinRelation.targetEntity.tableName,
                        subQuery: isSubQuery
                            ? { queryType: 'select', selects: [] }
                            : undefined
                    };
                    queryManager.updateJoinAlias(index, joinAlias, `${configPath}.joinAttributes`);
                    setAlias(alias);
                }, onDelete: () => {
                    queryManager.deleteJoin(index, `${configPath}.joinAttributes`);
                } }),
            join && (react_1.default.createElement(AliasSelector_1.default, { entity: join.targetEntity, value: alias, onChange: value => updateAlias(value) })),
            hasSubQuery && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(core_1.TextField, { size: 'small', variant: 'outlined', placeholder: 'Alias', className: 'input-field', value: alias, InputProps: {
                        endAdornment: (react_1.default.createElement(core_1.IconButton, { size: 'small', onClick: () => updateAlias('') },
                            react_1.default.createElement(icons_1.Close, { fontSize: 'small' })))
                    }, onChange: event => updateAlias(event.target.value) }),
                react_1.default.createElement(core_1.Typography, { variant: 'overline', className: 'on-label' }, "on"),
                react_1.default.createElement(JoinCondition_1.default, { vertical: vertical, expressionMap: config, joinAttribute: joinAttribute, condition: joinAttribute.condition || '', onChange: value => {
                        queryManager.updateJoinCondition(index, value, `${configPath}.joinAttributes`);
                    } })))),
        hasSubQuery && (react_1.default.createElement(SelectQueryBuilder_1.SelectQueryBuilderView, { configPath: `${configPath}.joinAttributes[${index}].alias.subQuery` }))));
};
exports.default = JoinSelector;
const getEntityPropertyString = (joinRelation) => `${joinRelation.alias}.${joinRelation.relation.propertyName}`;
//# sourceMappingURL=JoinSelector.js.map